import moment from 'moment';

import constants from '../../ahm-constants';

// @ts-expect-error - Automatic, Please fix when editing this file
const getDateOfBirthFromAge = (age) => {
  const guessedAge = moment().subtract(age, 'years').subtract(1, 'months'); // This needs to be done as api response can mistake todays date as not being 18.

  const lowerBounded = moment.max(moment('1900-01-01'), guessedAge);
  const upperBounded = moment.min(lowerBounded, moment());

  return upperBounded.format(constants.DATE_FORMAT.STANDARD);
};

export default getDateOfBirthFromAge;
